try {
            if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');
            else require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Button = forwardRef((_a, ref) => {
    var { variant = 'primary', size = 'small', type = 'button', children, className, iconPrefix, iconSuffix, isLoading } = _a, htmlProperties = __rest(_a, ["variant", "size", "type", "children", "className", "iconPrefix", "iconSuffix", "isLoading"]);
    const IconPrefixComponent = (iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.component) || Icon;
    const IconSuffixComponent = (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.component) || Icon;
    return (jsxs("button", Object.assign({ ref: ref, className: classNames('cds-btn', className, `cds-btn--${variant}`, `cds-btn--${variant}-${size}`), type: type }, htmlProperties, { children: [(iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.props) && (jsx(IconPrefixComponent, Object.assign({ className: classNames('icon__prefix', `icon--${variant}-icon`, {
                    'cds-btn--hide': isLoading,
                }) }, iconPrefix.props))), jsx("span", Object.assign({ className: classNames('cds-btn__inner', {
                    'cds-sr-only': variant.includes('-icon'),
                    'cds-btn--hide': isLoading,
                }) }, { children: children })), isLoading && (jsx("div", Object.assign({ className: classNames('cds-btn__loader', `cds-btn__loader--${variant}`) }, { children: jsx("span", {}) }))), (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.props) && (jsx(IconSuffixComponent, Object.assign({ className: classNames('icon__suffix', `icon--${variant}-icon`, {
                    'cds-btn--hide': isLoading,
                }) }, iconSuffix.props)))] })));
});

export { Button };
